import { ReactComponent } from "./drop-off-location.svg";

interface Props {
  width?: string;
  height?: string;
  fill?: string;
}

const DropOffLocationIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default DropOffLocationIcon;
